/**
 * SEO Configuration for all pages
 * Centralized metadata management for USA and New Zealand regions
 */

export const seoConfig = {
    // USA Region Pages
    us: {
        home: {
            title: "4WD Utility Vehicles Built for Work | Tuatara ATV USA",
            description: "Explore Tuatara UTVs in the USA – heavy-duty 4WD utility vehicles built for farms, worksites, and off-road performance. Expect power, durability, reliability.",
            keywords: "side by side UTV, utility vehicle, 4WD UTV",
            h1: "Heavy-Duty 4WD Utility Vehicles Built for Work",
        },
        utilityVehicles: {
            title: "Utility Vehicles USA - Explore 4WD UTVs | Tuatara ATV USA",
            description: "Explore Tuatara utility vehicles. Our heavy-duty 4WD UTV models are built for farms, worksites, and off-road terrain. Gas and electric options are available.",
            keywords: "electric UTVs, Utility vehicles",
            h1: "Tuatara UTVs Powered By Gas & Electric",
        },
        "1000EFI": {
            title: "1000 EFI Petrol UTV | Tuatara ATV USA",
            description: "The Tuatara 1000 EFI - powerful petrol-powered utility vehicle with electronic fuel injection for reliable performance in any condition.",
            keywords: "1000 EFI, petrol ATV, fuel injection, utility vehicle, Tuatara 1000",
        },
        "tu1500e2": {
            title: "TU-1500E-2 Electric UTV | Tuatara ATV USA",
            description: "TU-1500E-2 - Advanced electric utility vehicle delivering quiet, efficient power for sustainable farming and commercial operations.",
            keywords: "TU-1500E-2, electric ATV, electric utility vehicle, sustainable farming, Tuatara electric",
        },
        "tu1500e3": {
            title: "TU-1500E-3 Electric UTV | Tuatara ATV USA",
            description: "TU-1500E-3 - Next generation electric UTV with enhanced performance and extended range for demanding applications.",
            keywords: "TU-1500E-3, electric UTV, high performance ATV, Tuatara electric model",
        },
        // "tu1500e4": {
        //     title: "TU-1500E-4 Electric Model",
        //     description: "TU-1500E-4 - Premium electric utility vehicle featuring cutting-edge technology and superior off-road capability.",
        //     keywords: "TU-1500E-4, premium electric ATV, advanced UTV, Tuatara flagship",
        // },
        "tuDC2500E1": {
            title: "TU-DC2500E-1 Dual-Motor Electric UTV | Tuatara USA",
            description: "TU-DC2500E-1 - Dual motor electric powerhouse designed for extreme terrain and heavy-duty applications.",
            keywords: "TU-DC2500E-1, dual motor ATV, heavy duty UTV, extreme terrain vehicle",
        },
        "tuSC2500E1": {
            title: "TU-SC2500E-1 Electric UTV | Tuatara ATV USA",
            description: "TU-SC2500E-1 - High-capacity electric utility vehicle engineered for commercial and industrial use.",
            keywords: "TU-SC2500E-1, commercial ATV, industrial UTV, high capacity vehicle",
        },
        attachments: {
            title: "UTV Attachments & Accessories | Tuatara ATV USA",
            description: "Enhance your Tuatara with our range of professional attachments and accessories. From plows to cargo systems, we have everything you need.",
            keywords: "ATV attachments, UTV accessories, farm implements, Tuatara parts",
        },
        defend: {
            title: "Tactical & Defense UTVs | Tuatara ATV USA",
            description: "Tuatara utility vehicles for defense, security, and tactical applications. Rugged, reliable, and mission-ready.",
            keywords: "defense vehicles, tactical UTV, security ATV, military utility vehicle",
        },
        about: {
            title: "About Us | Heavy-Duty 4WD UTV Maker | Tuatara USA",
            description: "The story of Tuatara began with a New Zealand native who recognized the need for a better utility vehicle. Learn about our mission, vision, and values.",
            keywords: "Tuatara company, about Tuatara, UTV manufacturer, New Zealand vehicles",
        },
        warranty: {
            title: "Warranty, Service & Support | Tuatara ATV USA",
            description: "Comprehensive warranty coverage and expert service support for your Tuatara utility vehicle. We're here to keep you running.",
            keywords: "Tuatara warranty, ATV service, UTV support, vehicle maintenance",
        },
        dealers: {
            title: "Find a UTV Dealer Near You | Tuatara ATV USA",
            description: "Locate authorized Tuatara dealers near you. Experience our vehicles in person and get expert advice from our dealer network.",
            keywords: "Tuatara dealers, ATV dealers, find dealer, authorized retailers",
        },
        contact: {
            title: "Contact Us | UTV Sales & Support | Tuatara USA",
            description: "Get in touch with the Tuatara team. We're here to answer your questions and help you find the perfect utility vehicle.",
            keywords: "contact Tuatara, ATV inquiries, customer support",
        },
        service: {
            title: "UTV Service & Maintenance | Tuatara ATV USA",
            description: "Professional service and maintenance for your Tuatara utility vehicle. Keep your vehicle running at peak performance.",
            keywords: "Tuatara service, ATV maintenance, UTV repair, vehicle servicing",
        },
        accessories: {
            title: "Genuine UTV Accessories & Parts | Tuatara ATV USA",
            description: "Customize and enhance your Tuatara with genuine accessories. Quality parts designed specifically for your vehicle.",
            keywords: "Tuatara accessories, ATV parts, UTV upgrades, genuine accessories",
        },
        becomeADealer: {
            title: "Become an Official Tuatara USA Dealer | Tuatara ATV USA",
            description: "Join the Tuatara USA dealer network. Discover a low-overhead, high-opportunity business model and apply to become an authorized Tuatara dealer today.",
            keywords: "Tuatara dealer",
            h1: "Become a Tuatara Dealer",
        },
        blog: {
            title: "Tuatara Blog | ATV & UTV Guides, News & Insights",
            description: "Read practical guides on ATVs, UTVs, and side-by-sides. Compare vehicle types, learn which utility vehicle suits your property, and stay up to date with Tuatara.",
            keywords: "Tuatara blog, ATV vs UTV, side-by-side comparison, utility vehicle guide, farm vehicle tips, ATV buying guide",
        },
        blogDetail: {
            title: "Comparing ATVs vs UTVs and Side-by-Sides | Tuatara ATVs",
            description: "In this guide, we compare ATVs, UTVs, and side-by-sides to find the right utility vehicle for your property based on terrain, workload, and how you work.",
            keywords: "ATV vs UTV vs Side-by-Side, ATV vs UTV, side-by-side comparison, utility vehicle guide, Tuatara",
        },
    },

    // New Zealand Region Pages
    nz: {
        home: {
            title: "4WD ATVs & Side-by-Side UTVs for NZ Work | Tuatara ATV",
            description: "Explore Tuatara's all terrain vehicles — robust, reliable ATV/UTV side-by-sides in petrol and electric models built for off-road tasks. Enquire today.",
            keywords: "atv, side by side, utility vehicle, Tuatara NZ, New Zealand ATV, farm UTV, orchard vehicle, electric ATV NZ",
        },
        atvAccessories: {
            title: "ATV Accessories, Trailers & Parts | Tuatara Utility Add-Ons",
            description: "Browse Tuatara ATV accessories and parts designed to boost utility, protection and carrying capacity, including trailers for farm use. Shop the full range now.",
            keywords: "atv accessories, atv parts, atv trailer, ATV accessories NZ, Tuatara accessories, farm vehicle parts",
        },
        about: {
            title: "About Us & Our Utility ATV & UTV Vehicles | Tuatara ATV",
            description: "Learn about Tuatara ATV and our commitment to building durable ATV and UTV vehicles designed for tough terrain and long-term reliability. Discover our story.",
            keywords: "tuatara atv, tuatara utv, atv vehicle, Tuatara New Zealand, NZ manufacturer",
        },
        petrol: {
            title: "Tuatara 1000 EFI Petrol ATV | Tuatara ATVs",
            description: "Discover the Tuatara 1000 EFI petrol ATV — a robust 1000 cc side-by-side utility vehicle built for rugged terrain, towing and farm-work. Enquire today.",
            keywords: "petrol atv, tuatara 1000 efi, atv vehicle, petrol ATV NZ, farm vehicle, utility vehicle petrol",
        },
        electricAccessories: {
            title: "Tuatara 1500E All-Terrain EV | Electric ATV",
            description: "Discover the Tuatara EV 1500e, an electric ATV built for tough terrain and utility work. Quiet performance, high durability and zero-emissions. Enquire today.",
            keywords: "electric atv, electric utv, tuatara ev, electric ATV accessories, EV parts NZ, Tuatara electric",
        },
        orchardised: {
            title: "Low Profile Electric ATV — Removable Cabin | Tuatara ATVs",
            description: "Discover the low profile electric ATV with a removable cabin, offering quiet all-terrain performance for orchard/farm work. Explore and request details today.",
            keywords: "electric atv removable cabin, electric side by side, electric atv nz, orchard vehicle, vineyard ATV, low profile UTV, Tuatara orchardised",
        },
        electricDualMotor: {
            title: "Electric ATV — Dual-Motor 4x4 Side by Side | Tuatara",
            description: "Explore Tuatara's dual-motor electric ATV, a powerful 4x4 side by side with multi-passenger practicality and 6 seater ATV capability. Enquire today.",
            keywords: "electric atv, 4x4 side by side, 6 seater atv, dual motor electric, 4WD electric ATV, high performance UTV NZ",
        },
        gallery: {
            title: "All Terrain Vehicle Gallery — Tuatara 4x4s & 4 Seater ATVs",
            description: "View the Tuatara ATV gallery featuring 4x4 ATV and 4 seater models in action across farm, work and off-road environments. Explore the full range now.",
            keywords: "all terrain vehicle, 4 seater atv, 4x4 atv, Tuatara photos, ATV gallery, farm vehicles NZ",
        },
        contactUs: {
            title: "Contact Tuatara New Zealand | ATV & UTV Enquiries",
            description: "Contact Tuatara New Zealand. Get in touch for inquiries, dealer information, or to arrange a test drive.",
            keywords: "contact Tuatara NZ, New Zealand dealer, ATV inquiries",
        },
        blog: {
            title: "Tuatara Blog | Electric UTV Insights & Utility Vehicle Guides",
            description: "Explore guides on electric UTVs, UTV performance, and utility vehicle selection for New Zealand farms and properties. Practical insights from the Tuatara team.",
            keywords: "Tuatara blog, electric UTV, electric UTV performance, NZ farm vehicle, utility vehicle guide, Tuatara 1500E, 2500E UTV",
        },
        blogDetail: {
            title: "Are Electric UTVs Powerful Enough for Real Work? | Tuatara ATV",
            description: "Are electric UTVs powerful enough for real work? Learn how torque, load capacity, range, and work patterns affect real-world electric UTV performance.",
            keywords: "electric UTV, electric UTV performance, Tuatara 1500E, 2500E UTV, Tuatara, electric UTV NZ",
        },
    },

    // Dealer Portal Pages (Basic metadata - less critical for SEO)
    portal: {
        dashboard: {
            title: "Dealer Portal",
            description: "Tuatara Dealer Portal - Access vehicle parts, inventory, and dealer resources.",
            keywords: "dealer portal, parts lookup, inventory management",
        },
        partsLookup: {
            title: "Vehicle Parts Lookup",
            description: "Search and order genuine Tuatara parts and accessories for your customers.",
            keywords: "parts lookup, vehicle parts, Tuatara parts",
        },
        shoppingCart: {
            title: "Shopping Cart",
            description: "Review and complete your parts order.",
            keywords: "shopping cart, parts order",
        },
        inventory: {
            title: "Inventory List",
            description: "Manage your Tuatara vehicle inventory.",
            keywords: "inventory management, dealer inventory",
        },
    },
};

/**
 * Production origin used to build ABSOLUTE hreflang / cross-region alternate URLs.
 * hreflang must use absolute URLs on the canonical (non-www) host, so it is a
 * constant here rather than window.location.origin (which could be www / staging).
 */
export const SITE_ORIGIN = "https://tuataraatv.com";

/**
 * Reciprocal hreflang map: equivalent US <-> NZ pages.
 * Each entry emits en-US, en-NZ and x-default alternates on BOTH listed paths,
 * which keeps the annotations reciprocal (a one-sided hreflang is invalid and
 * ignored by Google). Paths are region-prefixed pathnames with NO trailing slash.
 *
 * Only genuine content equivalents are paired here. Product lines that map 1:1
 * across regions are included; pages that exist in a single region (or whose
 * cross-region counterpart is ambiguous/different content) are handled by
 * `singleRegionPages` below with a self-referential annotation instead, so we
 * never assert a false equivalence (which Google ignores or penalises).
 */
export const hreflangMap = [
    { us: "/us", nz: "/nz" },                                     // Homepage
    { us: "/us/about", nz: "/nz/about" },                         // About
    // { us: "/us/contact", nz: "/nz/ContactUs" },                // No live /us/contact route — /nz/ContactUs is self-referential below
    { us: "/us/blog", nz: "/nz/blog" },                           // Blog index
    // { us: "/us/accessories", nz: "/nz/Atv-Accessories" },      // No live /us/accessories route — /nz/Atv-Accessories is self-referential below
    { us: "/us/1000EFI", nz: "/nz/petrol" },                      // 1000 EFI petrol UTV
    { us: "/us/tu-1500e-2", nz: "/nz/electric-Accessories" },     // 1500E electric UTV
    { us: "/us/tu-DC2500E-1", nz: "/nz/electric-Dual-Motor" },    // DC2500E dual-motor electric UTV
];

/**
 * Pages that exist in only ONE region (no genuine cross-region equivalent).
 * Each emits a self-referential hreflang — its own locale plus x-default — so the
 * page is still annotated and passes hreflang validation, without claiming an
 * equivalent that doesn't exist. Paths have NO trailing slash.
 *
 * The two blog articles (/us/atv-vs-utv-vs-side-by-side and
 * /nz/electric-utv-work-performance) are intentionally NOT paired: they are
 * different articles, so they are treated as single-region content.
 */
export const singleRegionPages = {
    us: [
        // "/us/dealers",  // No live route in RegionApp — re-add when the page is wired up
        // "/us/service",  // No live route in RegionApp — re-add when the page is wired up
        "/us/warrnty",     // Service & Support page (route is "/warrnty")
        "/us/become-a-dealer",
        "/us/attachments",
        "/us/defend",      // route is "/defend" (not "/industries/defend")
        "/us/utility-vehicles",
        "/us/tu-1500e-3",
        "/us/tu-SC2500E-1",
        "/us/atv-vs-utv-vs-side-by-side",
    ],
    nz: [
        "/nz/ContactUs",        // NZ-only: no /us/contact route to pair with
        "/nz/Atv-Accessories",  // NZ-only: no /us/accessories route to pair with
        "/nz/Gallery",
        "/nz/Orchardised",
        "/nz/electric-utv-work-performance",
    ],
};

/**
 * Returns the hreflang alternate links to emit for a given pathname, or null when
 * the page is unknown (in which case no hreflang is emitted). Each link is
 * `{ hrefLang, href }` with an absolute URL on the canonical host.
 *
 *  - Paired pages   -> reciprocal en-US, en-NZ and x-default (x-default => US).
 *  - Single-region  -> self-referential own-locale + x-default.
 *
 * @param {string} pathname - location.pathname (trailing slash is ignored)
 * @returns {Array<{hrefLang: string, href: string}>|null}
 */
export const getHreflangLinks = (pathname) => {
    const normalized = pathname.replace(/\/+$/, "") || "/";

    const pair = hreflangMap.find(
        (e) => e.us === normalized || e.nz === normalized
    );
    if (pair) {
        return [
            { hrefLang: "en-US", href: `${SITE_ORIGIN}${pair.us}` },
            { hrefLang: "en-NZ", href: `${SITE_ORIGIN}${pair.nz}` },
            { hrefLang: "x-default", href: `${SITE_ORIGIN}${pair.us}` },
        ];
    }

    if (singleRegionPages.us.includes(normalized)) {
        return [
            { hrefLang: "en-US", href: `${SITE_ORIGIN}${normalized}` },
            { hrefLang: "x-default", href: `${SITE_ORIGIN}${normalized}` },
        ];
    }

    if (singleRegionPages.nz.includes(normalized)) {
        return [
            { hrefLang: "en-NZ", href: `${SITE_ORIGIN}${normalized}` },
            { hrefLang: "x-default", href: `${SITE_ORIGIN}${normalized}` },
        ];
    }

    return null;
};

/**
 * Get SEO metadata for a specific page
 * @param {string} region - Region code ('us' or 'nz')
 * @param {string} page - Page identifier
 * @returns {object} SEO metadata object
 */
export const getSEOMetadata = (region, page) => {
    const regionConfig = seoConfig[region] || seoConfig.us;
    return regionConfig[page] || {
        title: "4WD Utility Vehicles for Work & Off-Road | Tuatara ATV",
        description: "Tuatara - Premium utility vehicles for work and adventure.",
        keywords: "Tuatara, ATV, UTV, utility vehicle",
    };
};
